export default __webpack_public_path__ + "e97c3c1bf1985e4c86c6dcecfd9f7267.svg";